<template>
  <div class="box5">
    <div class="top-box">
      <pageTitle title="专业介绍" />  
      <div v-show="!isSticky" class="nav-box">
        <div
          class="nav"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <h3>{{ item.title }}</h3>
          <p>{{ item.english }}</p>
        </div>
      </div>
      <div v-show="isSticky" class="nav-box sticky">
        <div
          class="nav"
          v-for="(item, index) in navList"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <h3>{{ item.title }}</h3>
          <p>{{ item.english }}</p>
        </div>
      </div>
    </div>
    <!-- 人工智能硕士 -->
    <div class="content-box" v-if="cur === 0">
      <div class="con-box">
        <div class="title-btn"><p>专业详情</p></div>
        <div class="main-top-pic">
          <p>夏威夷太平洋大学的人工智能项目，精心设计了一系列前沿课程，旨在培养人工智能、数据统计分析等方向的高端人才，学生将掌握人工智能和机器学习、云计算、数据库等方面的基本理论，并在人工智能系统构建、人工智能数据挖掘、数据可视化等应用人工智能技术方向深入学习。</p>
        </div>
        <div class="table-box">
          <div class="right-title">通过项目学习，学员将深度掌握：</div>
          <div class="list-item" v-for="(item, index) in majorList" :key="index">
            <img src="../../../assets/coursePage/hawai/box5/list-arrow.png" /><p>{{ item.text }}</p>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>课程内容</p></div>
        <div class="title-text">夏威夷太平洋大学人工智能硕士项目毕业需完成10门课程的学习，共30学分</div>
        <div class="title-tips">*实际课程安排以学校每学期通知为准</div>
        <div class="con-list">
          <div class="list-item" v-for="(item, index) in leftList" :key="index">
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>学习模式</p></div>
        <div class="list-box">
          <div class="list-item" v-for="(item, index) in list" :key="index">
            <img class="left-icon" :src="item.icon" />
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>师资介绍</p></div>
        <div class="teacher-list-box">
          <div class="list-item" v-for="(item, index) in teacherList" :key="index">
            <div class="item-icon"></div>
            <div class="item-top">
              <img class="left-pic" :src="item.pic" />
              <div class="right-text">
                <div class="job">{{ item.job }}</div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
            <div class="education-box">
              <div class="education">{{ item.education1 }}</div>
              <div v-if="item.education2" class="education education2">{{ item.education2 }}</div>
            </div>
            <div class="description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 工商管理硕士 -->
    <div class="content-box content-box2" v-if="cur === 1">
      <div class="con-box">
        <div class="title-btn"><p>专业详情</p></div>
        <div class="main-top-pic">
          <p>夏威夷太平洋大学的MBA课程为学员掌握核心商业管理能力奠定了坚实的基础，注重培养学生的商业分析能力、决策和领导技能，这些综合能力对于做出正确的商业决策至关重要。通过全面的商业管理课程，MBA项目能增强学生的现有实力，帮助他们立即对其所在企业产生积极影响。</p>
        </div>
        <div class="table-box">
          <div class="right-title">掌握核心商业管理能力  成为高精尖管理人才</div>
          <img class="right-pic" src="../../../assets/coursePage/hawai/box5/detail-pic.png" />
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>课程内容</p></div>
        <div class="title-text">夏威夷太平洋大学工商管理硕士项目毕业需完成12门课程的学习，共32学分</div>
        <div class="title-tips">*实际课程安排以学校每学期通知为准</div>
        <div class="con-list">
          <div class="list-item" v-for="(item, index) in leftList2" :key="index">
            <div class="left-code">{{ item.code }}</div>
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>学习模式</p></div>
        <div class="list-box">
          <div class="list-item" v-for="(item, index) in list" :key="index">
            <img class="left-icon" :src="item.icon" />
            <div class="right-text">
              <div class="name">{{ item.name }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-box">
        <div class="title-btn"><p>商科教授</p></div>
        <div class="teacher-list-box">
          <div class="list-item" v-for="(item, index) in teacherList2" :key="index">
            <div class="item-icon"></div>
            <div class="item-top">
              <img class="left-pic" :src="item.pic" />
              <div class="right-text">
                <div class="job">{{ item.job }}</div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
            <div class="education-box">
              <div class="education">{{ item.education1 }}</div>
              <div v-if="item.education2" class="education education2">{{ item.education2 }}</div>
            </div>
            <div class="description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    return {
      cur: 0,
      isSticky: false,
      navList: [
        {
          title: "人工智能硕士", 
          english: "Master of Science in Artificial Intelligence"
        }, 
        {
          title: "工商管理硕士", 
          english: "Master of Business Administration"
        }, 
      ],
      majorList: [
        {
          text: '利用数学理论设计统计模型，估计系数和不确定性'
        },
        {
          text: '执行数据处理的六个步骤:发现、结构化、清理、丰富、验证和发布',
        },
        {
          text: '区分学习问题，选择机器学习和深度学习模型，并实施训练算法',
        },
        {
          text: '使用数据科学领域常用的编程语言编写代码，对数据进行清理、分析、可视化并创建模型',
        },
        {
          text: '创建和展示有效的数据可视化',
        },
        {
          text: '应用框架评估人工智能和数据科学中的伦理问题',
        },
      ],
      majorList2: [
        {
          job: '数据科学家职业',
          income: '$100,910',
        },
        {
          job: '机器学习工程师',
          income: '$111,630',
        },
        {
          job: '数据分析师',
          income: '$83,300', 
        },
        {
          job: '数据工程师',
          income: '$92,450', 
        },
        {
          job: '计算机与信息研究科学家',
          income: '$131,490', 
        },
        {
          job: '计算机系统分析师',
          income: '$99,270', 
        },
        {
          job: '大数据架构师',
          income: '$123,430',
        }
      ],
      leftList: [
        {
          name: '应用统计学与数据科学',
          description: 'Applied Statistics and Data Science'
        },
        {
          name: '编程基础(Python)',
          description: 'Programming for Data Scientists (Python)'
        },
        {
          name: '机器学习与数据科学',
          description: 'Data Science and Machine Learning'
        },
        {
          name: '数据可视化',
          description: 'Data Visualization'
        },
        {
          name: '人工智能中的伦理学',
          description: 'Ethics in Data Science and Artificial Intelligence'
        },
        {
          name: '基于结构化查询语言(SQL)的数据整理',
          description: 'Data wrangling with Structured Query Language'
        },
        {
          name: '文本挖掘与非结构化数据',
          description: 'Text Mining and Unstructured Data'
        },
        {
          name: '人工智能与机器学习',
          description: 'Al and Machine Learning'
        },
        {
          name: '数据架构与云计算',
          description: 'Data Architecture and Cloud Computing'
        },
        {
          name: '顶点课程',
          description: 'Data Science Capstone'
        },
      ],
      leftList2: [
        {
          code: '1学分',
          name: '硕士入门课程',
          description: 'To Prepare; Make Ready'
        },
        {
          code: '3学分',
          name: '数字时代的战略营销',
          description: 'Strategic Marketing in the Digital Age'
        },
        {
          code: '3学分',
          name: '面向管理者的财务信息',
          description: 'Financial Information for Managers'
        },
        {
          code: '3学分',
          name: '自我与他人的领导力',
          description: 'Leadership of Self & Other'
        },
        {
          code: '3学分',
          name: '复杂财务决策',
          description: 'Complex Financial Decision Making'
        },
        {
          code: '3学分',
          name: '跨境管理',
          description: 'Managing Across Borders'
        },
        {
          code: '3学分',
          name: '大数据商业分析',
          description: 'Business Analytics for Big Data'
        },
        {
          code: '3学分',
          name: '商业经济学',
          description: 'Economics for Business'
        },
        {
          code: '3学分',
          name: '战略管理',
          description: 'Strategic Management'
        },
        {
          code: '3学分',
          name: '项目实施方法',
          description: 'Methods of Project'
        },
        {
          code: '3学分',
          name: '顶点课程',
          description: 'Capstone Project'
        },
        {
          code: '1学分',
          name: '硕士毕业课程',
          description: 'Until We Meet Again'
        }
      ],
      list: [
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon1.png'),
          name: '上课形式',
          description: '纯线上学习，含院校教授的录播视频及学习材料，支持在线答疑互动，资深教务老师全程跟进学习进度，提供科学指导。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon2.png'),
          name: '考核标准',
          description: '教授根据学生作业完成情况、考试综合表现评判得分，总成绩合格，获得全部学分。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon3.png'),
          name: '毕业方案',
          description: '学生修满学分，可获得国外院校颁发的学位证书。学生可前往学校参加毕业典礼，或通过邮寄的形式获取学位证书。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon4.png'),
          name: '课后活动',
          description: '定期组织课后答疑、研讨会、学习互助小组及线下活动等。'
        },
      ],
      teacherList: [
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic1.png'),
          job: '教授',
          name: 'Chong Ho (Alex) Yu',
          education1: '亚利桑那州立大学测量、统计和方法研究博士',
          education2: 'SAS教师奖学金获得者、杰出 SAS 教育家奖',
          description: 'Chong Ho (Alex) Yu 教授致力于教授数据科学的核心课程，并指导学生进行数据伦理和文本挖掘等领域的研究。他的教学方法强调理论与实践相结合，帮助学生掌握数据科学的关键技能，为未来的学习和职业发展做好准备。'
        }, 
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic2.png'),
          job: '教授',
          name: 'Stewart Crawford',
          education1: '科罗拉多州立大学计算机科学博士',
          education2: '斯坦福大学运筹学硕士',
          description: 'Stewart Crawford教授专注于STEM教育中的编程与可视化、神经生物启发的计算与机器学习、图形与图像处理以及软件工程。他的教学方法不仅提升了学生对STEM学科的理解，还为他们未来的学习和职业发展奠定了坚实基础。'
        }, 
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic3.png'),
          job: '教授',
          name: 'Quinn Culver', 
          education1: '圣母大学数学博士学位',
          education2: '',
          description: 'Quinn Culver教授在相互作用定理证明、算法随机性、计算理论、数理逻辑和概率论等领域有深入研究。他致力于将先进的数学理论和教学技术融入课堂，为学生提供高质量的教育，培养他们的逻辑思维和数据分析能力。'
        }, 
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic4.png'),
          job: '教授',
          name: 'Rong Zou',
          education1: '日本九州大学应用数学博士',
          education2: '华中科技大学环境工程学士',
          description: 'Rong Zou教授在应用数学领域有深厚的研究造诣和授课经验，在教学过程中，Rong Zou教授善于指导学生运用理论和数值数学方法，探索和解决物理及现实问题，如流体动力学、数学建模、数据分析和优化等问题。' 
        }, 
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic5.png'),
          job: '教授',
          name: 'Yi Zhu',
          education1: '德克萨斯大学达拉斯分校计算机科学博士和硕士',
          education2: '上海交通大学电子信息工程专业学士和硕士',
          description: 'Yi Zhu教授在计算机网络、算法研究、网络设计等领域有显著成就。他的研究重点包括光组播技术、大数据和云计算的近似算法开发以及节能型网络设计等。他热衷于在课堂上与学生分享研究成果和真实案例，帮助学生为未来的学习、工作和生活做好充分的准备。' 
        },
      ],
      teacherList2: [
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic6.png'),
          job: '教授',
          name: 'Joseph Ha', 
          education1: '商学院市场营销系主任、教授',
          education2: '罗格斯大学市场营销学博士',
          description: 'Joseph教授拥有丰富的商业实战及教学经验，曾在纽约布鲁克林任连锁超市Met Food Supermarket总裁，2014年至今担任《营销思想杂志》编委会成员。Joseph以出色的教学能力，先后在多所美国知名院校担任教授，如罗格斯大学、南卡罗来纳大学等。'
        },
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic7.png'),
          job: '教授',
          name: 'Harm-Jan Steenhuis',
          education1: '商学院副院长，管理学教授',
          education2: '特文特大学国际技术贸易博士',
          description: 'Steenhuis博士先后出版了两本书和130多篇参考文章、书章节和会议论文集，曾深度参与哈佛商学院战略与竞争力研究所运营的竞争力微观经济学网络项目，在超过25个科学委员会任职。他是国际技术管理协会董事会成员、执行委员会的财务主管，曾任职于高科技企业孵化器斯波坎校际研究与技术研究所的董事会。' 
        },
        {
          pic: require('../../../assets/coursePage/hawai/box5/pic8.png'),
          job: '教授',
          name: 'MIchelle Alarcon',
          education1: '商学院管理学副教授',
          education2: '佩珀代因大学法学博士',
          description: 'Michelle教授拥有丰富的人力资源管理及商业顾问经验；曾任ARVInc.的执行官和人力资源高级副总裁，美国最大筹款组织PallottaTeamworks的人力资源和组织发展副总裁；比弗利山庄大型好莱坞酒店集团高级人力资源负责人；帝国酒店集团的人力资源总监和高级主管；她还为20世纪福克斯电影公司担任顾问，成功帮助其在迈阿密建立了第一个分部。' 
        },
      ]
    };
  },

  mounted() {
    // 监听窗口滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    changeCur(index) {
      this.cur = index;
      // 获取 nav-box 元素
      const navBox = this.$el;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (navBox) {
        // 获取 nav-box 元素的顶部位置
        const navBoxTop = navBox.getBoundingClientRect().top + scrollTop - 40;
        // 滚动到 nav-box 元素的位置
        window.scrollTo({
          top: navBoxTop,
          behavior: 'smooth' // 平滑滚动
        });
      }
    },
    handleScroll() {
      // 获取 .nav-box 元素和 .box5 元素
      const navBox = this.$el.querySelector('.nav-box');
      const box5 = this.$el;
      const navBoxTop = navBox.getBoundingClientRect().top;
      const box5Top = box5.getBoundingClientRect().top;
      const box5Bottom = box5.getBoundingClientRect().bottom;
       console.log(navBoxTop , box5Top , box5Bottom,this.isSticky)
      // 当滚动位置超过 .nav-box 元素的顶部位置且在 box5 区域内时，添加 sticky 类
      this.isSticky = navBoxTop <= 0 && box5Top <= 0 && box5Bottom > 90;
    }
  }
};
</script>

<style lang="less" scoped>
.box5 {
  position: relative;
  background: #F4F4FB; 
  .top-box {
    box-sizing: border-box;
    padding: 80px 0 0;
    width: 100%;
    height: 310px;
    background: url("../../../assets/coursePage/hawai/box5/top-title-bg.png") no-repeat;
    background-size: cover;
  }
  /deep/.course-title-box{
    .course-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #FFFFFF;
      line-height: 64px;
    }
    .course-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 52px;
    }
  } 
  .nav-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 118px;
    margin: 48px auto 0;
    will-change: position;
    // transition: all 1s ease-in-out;
    .nav {
      cursor: pointer;
      box-sizing: border-box;
      width: 50%;
      height: 114px;
      text-align: center;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      h3 {
        font-size: 34px;
        line-height: 48px;
      }
      p {
        margin-top: 2px;
        width: 300px;
        font-size: 20px;
        line-height: 20px;
        color: rgba(255,255,255,0.5);
      }
    }
    .cur-nav {
      position: relative;
      &::after {
        position: absolute;
        content: '';
        bottom: -15px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 218px;
        height: 14px;
        background: url("../../../assets/coursePage/stevens/box5/selected.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .sticky {
    height: 140px;
    margin: 0;
    padding-top: 26px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #017298; 
    -webkit-transform: translateZ(0); // 开启硬件加速
    transform: translateZ(0);
    will-change: position; // 提前告知浏览器位置即将变化
    transition: none; // 去除过渡效果
    .cur-nav {
      &::after {
        bottom: -36px; 
      }
    }
  }
  .content-box {
    padding: 40px 40px 80px;
    background: #FFFFFF;
    border-radius: 24px;
    .con-box {
      position: relative;
      margin-bottom: 40px;
      padding-bottom: 40px;
      width: 670px;
      background: #F2F8FA;
      border-radius: 32px;
      .main-top-pic {
        width: 710px;
        height: 384px;
        position: absolute;
        left: -20px;
        right: -20px;
        margin: 0 auto;
        top: 124px;
        background: url("../../../assets/coursePage/hawai/box5/top-bg-pic.png") no-repeat;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;
        p {
          width: 630px;
          font-weight: 400;
          font-size: 28px;
          color: #FFFFFF;
          line-height: 44px;
          text-align: justify;
        }
      }
      .table-box {
        box-sizing: border-box;
        padding: 548px 32px 0 28px;
        width: 670px;
        display: flex;
        flex-wrap: wrap;
        .right-title {
          width: 100%;
          font-weight: 600;
          font-size: 28px;
          color: #122A4F;
          line-height: 40px;
          text-align: justify;
        }
        .list-item {
          width: 100%;
          margin-top: 24px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          img {
            margin: 6px 8px 0 0;
            display: inline-block;
            width: 24px;
            height: 24px;
          }
          p {
            font-weight: 400;
            font-size: 26px;
            color: #122A4F;
            line-height: 40px;
            text-align: justify;
          }
        }
        // .list-item:nth-child(5) {
        //   height: 136px;
        // }
      }
    }
    .title-btn {
      box-sizing: border-box;
      position: absolute;
      top: 24px;
      left: -16px;
      padding: 8px 0 0 42px;
      width: 256px;
      height: 76px;
      background: url("../../../assets/coursePage/hawai/box5/title-bg.png") no-repeat;
      background-size: 100% 100%;
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #000000;
        line-height: 48px;
        text-align: left;
      }
    }
    .title-text {
      padding: 124px 40px 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #122A4F;
      line-height: 44px;
      text-align: left;
    }
    .title-tips {
      margin: 8px 0 0 40px;
      font-size: 24px;
      color: #017298;
      line-height: 40px;
      text-align: left;
    }
    .con-list {
      margin: 20px auto 0;
      font-family: PingFangSC, PingFang SC;
      width: 590px;
      .head-title {
        margin-bottom: 24px;
        width: 590px;
        height: 80px;
        background: #FFFFFF;
        border-radius: 16px;
        font-weight: 600;
        font-size: 32px;
        color: #272020;
        line-height: 80px;
        text-align: center;
      }
      .list-item {
        position: relative;
        padding: 24px 0;
        display: flex;
        justify-content: flex-start;
        &::after {
          position: absolute;
          content: '';
          display: block;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: 590px;
          border-bottom: 1px solid #DADCE4;
        }
        .left-code {
          width: 106px;
          font-weight: bold;
          font-size: 28px;
          line-height: 44px;
          text-align: left;
          color: transparent;
          background-image: linear-gradient(270deg, #00749C 0%, #092A52 100%);
          -webkit-background-clip: text;
        } 
        .right-text {
          .name {
            font-weight: 400;
            font-size: 28px;
            color: #122A4F;
            line-height: 44px;
            text-align: left;
          }
          .description {
            font-weight: 400;
            font-size: 24px;
            color: #017298;
            line-height: 40px;
            text-align: left;
          }
        }
      }
    }
    .list-box {
      padding: 124px 32px 0;
      .list-item {
        margin: 0 auto 24px;
        box-sizing: border-box;
        position: relative;
        padding: 40px 32px;
        display: flex;
        justify-content: flex-start;
        width: 606px;
        background: #FFFFFF;
        border-radius: 19px;
        .left-icon {
          width: 48px;
          height: 48px;
          margin-right: 24px;
        } 
        .right-text {
          .name {
            font-weight: 600;
            font-size: 32px;
            line-height: 48px;
            color: #122A4F;
            text-align: left;
          }
          .description {
            margin-top: 16px;
            font-weight: 400;
            font-size: 26px;
            color: #51627D;
            line-height: 40px;
            text-align: left;
          }
        }
      } 
      .list-item:last-child {
        margin-bottom: 0;
      }
    }
    .teacher-list-box {
      box-sizing: border-box;
      padding: 124px 32px 0;
      width: 670px;
      border-radius: 32px;
      .list-item {
        margin-bottom: 24px;
        position: relative;
        padding: 40px;
        border-radius: 26px;
        background: #FFFFFF;
        .item-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 72px;
          height: 72px;
          background: url('../../../assets/coursePage/hawai/box5/bg-icon.png') no-repeat;
          background-size: cover;
        }
        .item-top {
          display: flex;
          justify-content: flex-start;
          margin-bottom: 32px;
        }
        .left-pic {
          width: 216px;
          height: 216px;
          margin-right: 40px;
        } 
        .right-text {
          .name {
            margin-top: 8px;
            font-weight: 600;
            font-size: 40px;
            color: #122A4F;
            line-height: 52px;
            text-align: left;
          }
          .job {
            margin-top: 52px;
            font-weight: 400;
            font-size: 28px;
            color: #017298;
            line-height: 44px;
            text-align: left;
          }
        }
        .education {
          position: relative;
          margin-left: 20px;
          font-weight: 600;
          font-size: 28px;
          color: #122A4F;
          line-height: 44px;
          text-align: left;
          &::before {
            position: absolute;
            content: '';
            top: 16px;
            bottom: 0;
            left: -20px;
            content: '';
            width: 8px;
            height: 8px;
            background: #017298;
            border-radius: 50%;
          }
        }
        .description {
          margin-top: 24px;
          font-weight: 400;
          font-size: 26px;
          color: #51627D;
          line-height: 40px;
          text-align: left;
        }
      }
      .list-item:nth-child(4), .list-item:nth-child(5) {
        .right-text {
          .job {
            margin-top: 104px;
          }
        }
      }
      .list-item:last-child {
        margin-bottom: 0; 
      }
      .list-item:nth-child(3) {
        .item-top {
          .right-text {
            .name {
              width: 150px;
            }
          }
        }
      }
    }
    .con-box:last-child {
      padding-bottom: 32px;
      margin-bottom: 0;
    } 
  }
  .content-box2 {
    .con-box {
      // .main-top-pic {
      //   height: 472px;
      //   background: url("../../../assets/coursePage/stevens/box5/top-bg-pic2.png") no-repeat;
      //   background-size: cover;
      // }
      .table-box {
        padding: 548px 28px 0;
        .right-title {
          text-align: center;
        }
        .right-pic {
          margin-top: 32px;
          display: block;
          width: 614px;
        }
      }
      .teacher-list-box {
        .list-item {
          .right-text {
            .job {
              margin-top: 52px;
            }
            .name {
              margin-top: 4px;
            }
          }
        }
        .list-item:nth-child(1) {
          .right-text {
            .job {
              margin-top: 104px;
            }
          }
        }
      }
    }
  }
}
</style>
